import Button, { ButtonProps } from '@material-ui/core/Button';
import { Theme, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { PropColor } from '../../types/materialUi';

const useStyles = makeStyles((theme: Theme) => ({
	button: (props: Props) => ({
		width: props.fullWidth ? '100%' : 'inherit',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
		padding: theme.spacing(1, 2),
		boxShadow: 'none',
		'&:hover': {
			boxShadow: 'none',
		},
		borderRadius: 0,
	}),
}));

interface Props {
	className?: string;
	fullWidth?: boolean;
}

export const GenericButton: React.FC<Props & ButtonProps> = (props) => {
	const { variant, color, className, ...rest } = props;
	const classes = useStyles(props);

	return (
		<Button
			className={`${classes.button} ${className}`}
			variant={variant || 'contained'}
			color={color || PropColor.PRIMARY}
			{...rest}
		>
			{props.children}
		</Button>
	);
};
